import React from 'react';
import { Outlet } from 'react-router';
import { Watermark } from '@link/share/components';
import { isProd } from '@link/portal/utils';
import linktivity from '@link/portal/assets/linktivity.svg';
import { useTranslation } from 'react-i18next';
import styles from './base.module.css';

const BaseLayout: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.base}>
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <span className={styles.title}>{t('views.voucher.title')}</span>
          <div>
            <span className={styles.poweredBy}>Powered by</span>
            <img src={linktivity} alt="Logo" className={styles.logo} />
          </div>
        </div>
      </header>
      <main className={styles.main}>
        <Outlet />
      </main>
      {!isProd && <Watermark />}
    </div>
  );
};

export default BaseLayout;
